import React, { Component } from 'react';
const Heading = () => {

    return (
        <div className="border-4 border-gray-800 m-2 p-2 flex-auto">
        <div className="text-sky-300  font-semibold text-center md:text-6xl text-4xl">
          welcome to iBox
        </div>
        <p className="text-gray-300 text-center md:text-4xl text-2xl">we are ready to serve your memories...</p>
      </div>
    );
}
export default Heading;